/* Built In Imports */
import { useEffect } from 'react';

/* External Imports */
import { Box, Flex } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Loader from '@components/Utility/Loader';

/* Services */

/**
 *
 */
export default function Region() {
  useEffect(function onFirstMount() {
    window.location.reload();
  }, []);

  return (
    <Box w="100%" h="200px">
      <Flex alignItems="center" w="inherit" h="60%">
        <Loader />
      </Flex>
      <style jsx global>
        {`
          body {
            background: #f8f6f3;
          }
        `}
      </style>
    </Box>
  );
}
